// src/hooks/useStudent.js
import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebase";

export function useStudent() {
  const [student, setStudent] = useState(null);
  const [course,  setCourse]  = useState(null);
  const [batch,   setBatch]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  async function load() {
    const uid = auth.currentUser?.uid;
    if (!uid) { setLoading(false); return; }
    try {
      const studentId = sessionStorage.getItem("activeStudentId") || uid;
      const sSnap = await getDoc(doc(db, "students", studentId));
      if (!sSnap.exists()) { setLoading(false); return; }
      const s = sSnap.data();
      setStudent({ id: studentId, ...s });
      if (s.courseId) {
        const cSnap = await getDoc(doc(db, "courses", s.courseId));
        if (cSnap.exists()) setCourse({ id: s.courseId, ...cSnap.data() });
      }
      if (s.batchId) {
        const bSnap = await getDoc(doc(db, "batches", s.batchId));
        if (bSnap.exists()) setBatch({ id: s.batchId, ...bSnap.data() });
      }
    } catch(e) { console.error(e); }
    setLoading(false);
  }

  function refresh() { setLoading(true); load(); }

  return { student, course, batch, loading, refresh };
}
